import { createAsyncThunk } from '@reduxjs/toolkit';

export const forgotPasswords = createAsyncThunk(
  'auth/forgotPasswords',
  async (email, { rejectWithValue }) => {
    try {
      const response = await fetch('http://localhost:5000/api/forgot-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const resetPasswords = createAsyncThunk(
  'auth/resetPassword',
  async ({ token, id, newPassword }, { rejectWithValue }) => {
    try {
      const response = await fetch(`http://localhost:5000/api/reset-password/${id}/${token}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ newPassword }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);